/**
 * Performs a match for the given string word by word, such that
 * 'Example Test String' would be matched by 'ex stri'
 *
 * @param {string} inputString
 * @param {string} searchTerm
 * @param {boolean} [midWordPartialsAllowed]
 */
function sequentialWordSearch(
	inputString,
	searchTerm,
	midWordPartialsAllowed = false
) {
	const inputWordsArray = inputString.trim().toLowerCase().split(' ');
	const searchTermWordsArray = searchTerm.trim().toLowerCase().split(' ');

	for (const inputWord of inputWordsArray) {
		for (const searchWord of searchTermWordsArray) {
			if (midWordPartialsAllowed) {
				if (inputWord.includes(searchWord)) {
					// Match found, remove search term and continue
					searchTermWordsArray.shift();
					break;
				}
			} else {
				if (inputWord.startsWith(searchWord)) {
					// Match found, remove search term and continue
					searchTermWordsArray.shift();
					break;
				}
			}
		}
		// End early if we finished matching all terms
		if (searchTermWordsArray.length === 0) {
			break;
		}
	}

	// String matches if all search word were matched
	return searchTermWordsArray.length === 0;
}


export {sequentialWordSearch}
